module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "dn-submenu"
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: (item.url_id),
        expression: "item.url_id"
      }],
      key: index,
      class: ("dn-submenu__item" + (item.className ? ' ' + item.className : '')),
      attrs: {
        "href": item.href,
        "target": item.target
      }
    }, [_c('span', {
      staticClass: "dn-icon dn-icon-arrow-right"
    }), _c('span', {
      staticClass: "dn-submenu__text",
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })])
  }), _vm._v(" "), _c('a', {
    staticClass: "dn-submenu__item",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showAttributeDialog
    }
  }, [_c('span', {
    staticClass: "dn-icon dn-icon-arrow-right"
  }), _c('span', {
    staticClass: "dn-submenu__text"
  }, [_vm._v("属性確認")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da5e003","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/navigations/Submenu.vue
// module id = 371
// module chunks = 1